import CreateWalletTypeSelector from "./CreateWalletTypeSelector";

export default CreateWalletTypeSelector;
